var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.66,33.5l-6.73-1.82V6.35c0-.84-.69-1.51-1.52-1.51H13.05c-.84,0-1.51,.68-1.51,1.51V40.63c0,5.27,3.55,9.91,8.64,11.29l26.71,7.22c3.02,.84,6.34-1.02,7.15-4.11,2.52-9.34-3.03-19-12.37-21.54h0ZM14.57,7.86H31.91v3.49H14.57v-3.49Zm10.58,42.27l-4.17-1.13c-3.77-1.02-6.41-4.46-6.41-8.37v-3.19c2.89-.11,5.72,.98,7.78,3.04,2.53,2.54,3.56,6.2,2.8,9.65h0Zm25.96,4.12c-.4,1.49-1.92,2.36-3.43,1.97l-19.6-5.3c1.04-4.49-.28-9.27-3.58-12.58-2.63-2.63-6.23-4.03-9.91-3.93V14.39H31.91v18.46c0,.69,.46,1.29,1.12,1.46l7.85,2.12c7.73,2.09,12.32,10.09,10.23,17.82h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocks);
export default __webpack_public_path__ + "static/media/icon_socks.1e82a1be.svg";
export { ForwardRef as ReactComponent };